import React from "react";

const MyVideos: React.FC = () => {
  const handleSignIn = () => {
    window.location.href = "https://pixelmaker.ai?utm_source=pixelmaker_io";
  };

    return (
      <div className="bg-black dark:bg-black p-4 md:p-6 lg:p-8 pb-32 md:pb-6">
        <div className="text-center py-12">
        <div className="max-w-md mx-auto">
          <div className="w-20 h-20 bg-gradient-to-br from-gray-600 to-gray-700 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg
              className="w-10 h-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
              />
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">
            Your Assets
          </h2>
          <p className="text-gray-400 mb-8">
            Sign in to view and manage your generated videos and images.
          </p>
          <button
            onClick={handleSignIn}
            className="px-8 py-3 bg-white text-black font-semibold rounded-lg hover:bg-gray-200 transition-all duration-200"
          >
            Sign In to Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyVideos;
